<span>{{ dateTime ? formatDateTime(dateTime) : '' }}</span>
